<div class="acerto-shell">
  <div class="acerto-titlebar">
    <div class="modal-titlebar">
      <div class="modal-title-icon">
        <i class="fas fa-wallet"></i>
      </div>
      <span>Acerto de Fiado</span>
    </div>

    <button type="button" class="btn-fechar-acerto" (click)="fecheModal()">
      <i class="fas fa-times"></i>
    </button>
  </div>

  <div class="acerto-modal">
  <div class="cliente-card">
    <div class="cliente-avatar">
      <i class="fas fa-user"></i>
    </div>

    <div class="cliente-info">
      <div class="cliente-topo">
        <h5 class="cliente-nome">{{contato?.nome}}</h5>
        <span class="cliente-badge">Cliente</span>
      </div>

      <div class="cliente-contato">
        <span>{{contato?.telefone || '-'}}</span>
        <i class="fas fa-phone-alt"></i>
      </div>

      <div class="cliente-saldo" *ngIf="contato?.contaFinanceira">
        Crédito disponível:
        <strong>{{obtenhaSaldoDisponivel() | currency:'BRL'}}</strong>
      </div>
    </div>

    <div class="resumo-inline">
      <div class="resumo-icone">
        <i class="fas fa-wallet"></i>
      </div>
      <div>
        <div class="resumo-label">Total do acerto</div>
        <div class="resumo-total">{{obtenhaTotalSelecionado() | currency:'BRL'}}</div>
      </div>
      <div class="resumo-separador"></div>
      <div class="resumo-quantidade">
        {{obtenhaQuantidadeSelecionada()}} {{obtenhaQuantidadeSelecionada() === 1 ? 'pedido' : 'pedidos'}}<br>
        selecionados
        <button type="button" class="btn-ver-pedidos" (click)="abraPedidos()">ver pedidos</button>
      </div>
    </div>
  </div>

  <div class="alert alert-danger mb-3" *ngIf="erro">
    {{erro}}
  </div>

  <div class="acerto-conteudo">
    <div class="pagamento-card">
      <ng-container *ngIf="pagoIntegralmenteComSaldo(); else formasPagamentoAcerto">
        <div class="pagamento-credito-card">
          <div class="pagamento-credito-titulo">
            <div class="forma-icone cor-violet">
              <i class="fas fa-credit-card"></i>
            </div>

            <div>
              <div class="pagamento-credito-heading">Valor pago agora</div>
              <div class="pagamento-credito-subtitulo">Usando saldo do cliente</div>
            </div>
          </div>

          <div class="pagamento-credito-grid">
            <div class="credito-total-card">
              <div class="credito-total-valor">{{obtenhaTotalSelecionado() | currency:'BRL'}}</div>
              <div class="credito-total-badge">
                <i class="fas fa-check"></i>
                Pago 100% com saldo da conta
              </div>

              <button type="button" class="btn-outra-forma" (click)="pagueComOutraForma()">
                <i class="fas fa-credit-card"></i>
                Pagar com outra forma de pagamento
              </button>

              <div class="credito-total-ajuda">
                Você pode usar parte do saldo e complementar o pagamento com outra forma.
              </div>
            </div>

            <div class="credito-detalhes-card">
              <div class="credito-detalhe-linha">
                <div class="credito-detalhe-label">
                  <span class="credito-detalhe-icone"><i class="fas fa-plus-circle"></i></span>
                  Crédito disponível
                </div>
                <strong>{{obtenhaSaldoDisponivel() | currency:'BRL'}}</strong>
              </div>

              <div class="credito-detalhe-linha">
                <div class="credito-detalhe-label">
                  <span class="credito-detalhe-icone"><i class="fas fa-arrow-down"></i></span>
                  Saldo utilizado
                </div>
                <strong>{{obtenhaValorSaldoInformado() | currency:'BRL'}}</strong>
              </div>

              <div class="credito-detalhe-linha">
                <div class="credito-detalhe-label">
                  <span class="credito-detalhe-icone"><i class="fas fa-wallet"></i></span>
                  Saldo restante
                </div>
                <strong>{{obtenhaSaldoRestanteAposAcerto() | currency:'BRL'}}</strong>
              </div>
            </div>
          </div>

          <div class="resumo-linhas resumo-credito">
            <div class="resumo-linha">
              <span>Saldo utilizado</span>
              <strong>{{obtenhaValorSaldoInformado() | currency:'BRL'}}</strong>
            </div>
            <div class="resumo-linha">
              <span>Total pago</span>
              <strong>{{obtenhaTotalSelecionado() | currency:'BRL'}}</strong>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-template #formasPagamentoAcerto>
      <div class="secao-titulo">Forma de pagamento</div>

      <div class="saldo-uso-card" *ngIf="deveExibirBlocoSaldo()"
           [class.selecionada]="obtenhaValorSaldoInformado() > 0">
        <button type="button" class="saldo-uso-check" (click)="alterneUsoSaldo()">
          <i class="fas" [ngClass]="obtenhaValorSaldoInformado() > 0 ? 'fa-check' : 'fa-wallet'"></i>
        </button>

        <div class="forma-icone cor-green">
          <i class="fas fa-wallet"></i>
        </div>

        <div class="saldo-uso-info">
          <div class="forma-titulo">Usar saldo do cliente</div>
          <div class="forma-subtitulo">Use seu crédito disponível para abater do total do acerto.</div>
        </div>

        <div class="saldo-uso-campo">
          <label>Usar neste acerto</label>
          <kendo-numerictextbox
            [(ngModel)]="dados.valorSaldoUtilizado"
            (ngModelChange)="atualizeValorPagamentoSugerido()"
            [min]="0"
            [max]="obtenhaValorSaldoMaximo()"
            format="c2">
          </kendo-numerictextbox>
          <small>Você pode reduzir este valor, se desejar.</small>
        </div>

        <div class="saldo-disponivel-card">
          <span>Disponível</span>
          <strong>{{obtenhaSaldoDisponivel() | currency:'BRL'}}</strong>
        </div>
      </div>

      <div class="formas-grid" *ngIf="deveExibirFormasPagamento()">
        <button type="button"
                class="forma-card"
                *ngFor="let forma of formasDePagamento"
                [class.selecionada]="formaSelecionada(forma)"
                (click)="selecioneFormaDePagamento(forma)">
          <div class="forma-icone" [ngClass]="'cor-' + obtenhaCorFormaPagamento(forma)">
            <i class="fas" [ngClass]="obtenhaIconeFormaPagamento(forma)"></i>
          </div>

          <div class="forma-conteudo">
            <div class="forma-titulo">{{obtenhaTituloFormaPagamento(forma)}}</div>
          </div>

          <div class="forma-check" *ngIf="formaSelecionada(forma)">
            <i class="fas fa-check-circle"></i>
          </div>
        </button>
      </div>

      <div class="pagamento-agora-card" *ngIf="deveExibirPagamentoAgora()">
        <div class="pagamento-agora-titulo">
          <div class="forma-icone cor-violet">
            <i class="fas fa-credit-card"></i>
          </div>
          <span>Valor pago agora</span>
        </div>

        <div class="pagamento-grid">
          <div class="pagamento-campo">
            <kendo-numerictextbox
              [(ngModel)]="dados.valorPagamento"
              [min]="0"
              class="valor-input"
              format="c2">
            </kendo-numerictextbox>
          </div>

          <div class="pagamento-ajuda">
            <div class="pagamento-ajuda-linha">
              <span>Complemento com</span>
              <strong>{{obtenhaTituloFormaPagamentoSelecionada()}}</strong>
            </div>
            <div *ngIf="obtenhaValorFaltante() > 0" class="texto-alerta">
              Falta cobrir {{obtenhaValorFaltante() | currency:'BRL'}}
            </div>
            <div *ngIf="obtenhaValorExcedente() > 0" class="texto-sucesso">
              Excedente de {{obtenhaValorExcedente() | currency:'BRL'}} será convertido em crédito.
            </div>
          </div>
        </div>

        <div class="resumo-linhas">
          <div class="resumo-linha">
            <span>Usar saldo</span>
            <strong>{{obtenhaValorSaldoInformado() | currency:'BRL'}}</strong>
          </div>
          <div class="resumo-linha" *ngIf="obtenhaFormaPagamentoSelecionada()">
            <span>{{obtenhaTituloFormaPagamentoSelecionada()}}</span>
            <strong>{{obtenhaValorPagamentoInformado() | currency:'BRL'}}</strong>
          </div>
          <div class="resumo-linha destaque" *ngIf="obtenhaValorExcedente() > 0">
            <span>Vira crédito</span>
            <strong>{{obtenhaValorExcedente() | currency:'BRL'}}</strong>
          </div>
          <div class="resumo-linha total-pago">
            <span>Total pago</span>
            <strong>{{obtenhaTotalPagoAgora() | currency:'BRL'}}</strong>
          </div>
        </div>
      </div>

      <div class="resumo-linhas" *ngIf="!deveExibirPagamentoAgora()">
        <div class="resumo-linha">
          <span>Usar saldo</span>
          <strong>{{obtenhaValorSaldoInformado() | currency:'BRL'}}</strong>
        </div>
        <div class="resumo-linha" *ngIf="obtenhaValorPagamentoInformado() > 0">
          <span>Pagamento</span>
          <strong>{{obtenhaValorPagamentoInformado() | currency:'BRL'}}</strong>
        </div>
        <div class="resumo-linha destaque" *ngIf="obtenhaValorExcedente() > 0">
          <span>Vira crédito</span>
          <strong>{{obtenhaValorExcedente() | currency:'BRL'}}</strong>
        </div>
      </div>
      </ng-template>
    </div>
  </div>

  <div class="secao">
    <label class="secao-titulo mb-2">Observação</label>
    <textarea class="form-control observacao-input"
              [(ngModel)]="dados.observacao"
              maxlength="150"
              rows="3"
              placeholder="Adicione observações sobre este acerto (opcional)"></textarea>
    <div class="observacao-contador">{{(dados.observacao || '').length}}/150</div>
  </div>

  <div class="acoes">
    <button class="btn btn-cancelar" type="button" (click)="fecheModal()">Cancelar</button>
    <button class="btn btn-confirmar" type="button" (click)="onSubmit()" [disabled]="carregando">
      <i class="far fa-check-circle"></i>
      Confirmar acerto
    </button>
  </div>

  <div class="modal-pedidos-backdrop" *ngIf="exibindoPedidos">
    <div class="modal-pedidos">
      <div class="modal-pedidos-header">
        <div>
          <h5>Pedidos em aberto</h5>
          <span>{{obtenhaQuantidadeSelecionada()}} selecionados</span>
        </div>
        <button type="button" class="btn-fechar-pedidos" (click)="fechePedidos()">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="pedidos-tabela desktop-only">
        <div class="pedidos-head">
          <div class="col-check"></div>
          <div class="col-pedido">Pedido</div>
          <div class="col-saldo">Saldo</div>
          <div class="col-valor">Valor a pagar</div>
        </div>

        <div class="pedido-row" *ngFor="let lancamento of lancamentos">
          <div class="col-check">
            <input type="checkbox"
                   [(ngModel)]="itemSelecionado(lancamento.id).selecionado"
                   (ngModelChange)="atualizeValorPagamentoSugerido()"
                   class="k-checkbox"
                   kendoCheckBox />
          </div>
          <div class="col-pedido pedido-codigo">#{{lancamento?.pedido?.codigo}}</div>
          <div class="col-saldo">{{lancamento?.saldo | currency:'BRL'}}</div>
          <div class="col-valor">
            <kendo-numerictextbox
              [(ngModel)]="itemSelecionado(lancamento.id).valorPago"
              (ngModelChange)="atualizeValorPagamentoSugerido()"
              [min]="0"
              [max]="lancamento.saldo"
              format="c2"
              class="valor-input">
            </kendo-numerictextbox>
          </div>
        </div>
      </div>

      <div class="pedidos-mobile mobile-only">
        <div class="pedido-mobile-card" *ngFor="let lancamento of lancamentos">
          <div class="pedido-mobile-linha">
            <input type="checkbox"
                   [(ngModel)]="itemSelecionado(lancamento.id).selecionado"
                   (ngModelChange)="atualizeValorPagamentoSugerido()"
                   class="k-checkbox"
                   kendoCheckBox />

            <div class="pedido-mobile-resumo">
              <div class="pedido-codigo">#{{lancamento?.pedido?.codigo}}</div>
              <div class="pedido-mobile-saldo-label">Saldo</div>
              <div class="pedido-mobile-saldo">{{lancamento?.saldo | currency:'BRL'}}</div>
            </div>

            <div class="pedido-mobile-valor">
              <label>Valor a pagar</label>
              <kendo-numerictextbox
                [(ngModel)]="itemSelecionado(lancamento.id).valorPago"
                (ngModelChange)="atualizeValorPagamentoSugerido()"
                [min]="0"
                [max]="lancamento.saldo"
                format="c2"
                class="valor-input">
              </kendo-numerictextbox>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-pedidos-acoes">
        <button class="btn btn-confirmar" type="button" (click)="fechePedidos()">Aplicar</button>
      </div>
    </div>
  </div>
  </div>
</div>
